const Tools = {
  CDN: 'https://cdn.myfunnow.com',
  UUID: (function () {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }
    return 'WEB-' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  })(),
  nl2br(str) {
    const breakTag = '<br>'
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
  },
  removeNewLine(str = '') {
    return str.replace(/\r?\n|\r|\t/g, '')
  },
  thumbImagePath(path) {
    if (!path) {
      return '/web/images/default.png'
    }
    if (path.startsWith('/') === false) {
      path = '/' + path
    }
    const index = path.lastIndexOf('/')
    const prefix = path.substring(0, index)
    const suffix = path.substr(index)
    return prefix + '/thumbnail/' + encodeURIComponent(suffix)
  },
  imagePath(path) {
    if (!path) {
      return '/web/images/default.png'
    }
    if (path.startsWith('/') === false) {
      path = '/' + path
    }
    const index = path.lastIndexOf('/')
    const prefix = path.substring(0, index)
    const suffix = path.substr(index)
    return prefix + encodeURIComponent(suffix)
  },
  isEmpty(obj) {
    // null and undefined are "empty"
    if (obj == null) {
      return true
    }

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) {
      return false
    }
    if (obj.length === 0) {
      return true
    }

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== 'object') {
      return true
    }

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (const key in obj) {
      if (hasOwnProperty.call(obj, key)) {
        return false
      }
    }
    return true
  },
  getQueryString(obj) {
    if (Tools.isEmpty(obj)) {
      return ''
    }

    let query = '?'
    for (const item in obj) {
      query += item + '=' + obj[item] + '&'
    }
    query = query.replace(/&+$/, '')
    return query
  },
  prefix(locale) {
    return locale === 'en' ? '' : '/' + locale
  },
  chunk(collection, size) {
    const result = []
    size = parseInt(size) || 1
    for (let x = 0; x < Math.ceil(collection.length / size); x++) {
      const start = x * size
      const end = start + size

      result.push(collection.slice(start, end))
    }

    return result
  },
  getMediaCdnUrl(url) {
    if (url?.startsWith('http')) {
      return url
    }
    return `${Tools.CDN}${Tools.imagePath(url)}`
  },
}

export default Tools
